export default __webpack_public_path__ + "static/media/contentMarketing3.6327e464.jpg";